(function(){
    'use strict'; 
    angular.module('Services').factory('GoogleMapService', function(Request) {
        return {
            geocoder: function(successCallback, errorCallback, data) {
                Request.post({
                    method: 'POST',
                    url: ApiURLs.gmap.geocoder,
                    successCallback, 
                    errorCallback, 
                    data
                });
            },
            latLngToAddress: function(successCallback, errorCallback, data) {
                Request.post({
                    method: 'POST', 
                    url: ApiURLs.gmap.address, 
                    successCallback,
                    errorCallback,
                    data
                });
            }
        }
    });
})();


// WEBPACK FOOTER //
// ./js/services/GoogleMapService.js